import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mess',
  templateUrl: './mess.component.html',
  styleUrls: ['./mess.component.scss']
})
export class MessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
